<template>
  <b-card>
    <b-card-text>
      <div v-if="bookingItems.length > 0 && !!recipient">
        <p>{{ trans('checkout_confirmation_booking') }}</p>
        <ul>
          <li v-for="item in bookingItems" :key="item.id">
            {{ item.name }}
            <ul v-if="item.booked_location_summary">
              <li>
                {{ item.booked_location_summary }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <p>
        {{ trans('check_email_for_' + (invoice.is_service_offer ? 'service_offer' : 'receipt')) }}
        <b-button variant="outline-branded" class="py-0 ml-2" :href="invoice.invoice_url" target="_blank">
          {{ trans('download_pdf') }}
        </b-button>
      </p>
      <p v-if="invoice.has_interac_pending" class="text-success">
        <em>
          <i class="fa fa-info-circle"></i>
          {{ trans('interac_pending_note') }}
        </em>
      </p>
      <p v-if="showAutocancelWarning" class="text-danger">
        <em>
          <i class="fa fa-exclamation-triangle"></i>
          {{ trans('automatic_cancellation_checkout_warning').replace(':minutes', autocancelDelay) }}
        </em>
      </p>
      <div v-if="invoice.confirmation_forms && invoice.confirmation_forms.length > 0" class="mb-4">
        <p>{{ trans('before_event_please_fill_form' + (invoice.confirmation_forms.length > 1 ? 's' : '')) }}</p>
        <b-row>
          <b-col class="col-md-8">
            <b-button v-for="form in invoice.confirmation_forms" :key="form.id" variant="branded" block class="mb-2" :href="form.url" target="_blank">
              {{ form.name }}
              <i class="fa fa-fw fa-external-link-alt"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-if="invoice.confirmation && invoice.confirmation.coupons && invoice.confirmation.coupons.length > 0">
        <p>
          <strong>{{ trans('use_your_coupon' + (invoice.confirmation.coupons.length > 0 ? 's' : '')) }}</strong>
          <small class="d-block text-muted">
            {{ trans('use_coupons_later') }}
          </small>
        </p>
        <coupons
          :organization="organization"
          :initial-coupons="invoice.confirmation.coupons"
          class="mb-3"
        ></coupons>
      </div>
      <p>
        <b-button variant="outline-branded" :href="continueShoppingUrl || `${iframeUrlPrefix}/org/${organization.id}${session}`">
          <i class="fa fa-fw fa-reply"></i>
          {{ trans('continue_shopping') }}
        </b-button>
        <b-button variant="outline-branded" class="ml-2" :href="`${iframeUrlPrefix}/org/${organization.id}/client${session}`">
          <i class="fa fa-fw fa-user"></i>
          {{ trans('my_account') }}
        </b-button>
        <b-button v-if="canSendInvoice" variant="outline-danger" class="ml-2" v-b-modal.pos-send-invoice-modal>
          <i class="fa fa-fw fa-envelope"></i>
          {{ trans('send_invoice') }}
        </b-button>
      </p>
    </b-card-text>
    <pos-send-invoice-modal
      :organization="organization"
      :invoice="invoice"
    ></pos-send-invoice-modal>
    <send-message-modal
      v-if="canSendInvoice"
      id="confirmation-send-invoice-modal"
      :organization="organization"
      :user="organization.auth_user"
      type="email"
      :subject="trans('invoice')"
      :people="invoice.is_no_client ? [] : [invoice.recipient]"
      :message-sample-id="invoice.balance > 0 ? 'invoice_pay_balance' : 'invoice'"
      :invoice_no="invoice.invoice_no"
      @sent="onInvoiceSent"
    ></send-message-modal>
  </b-card>
</template>

<script>
  import Coupons from './../client/Coupons'
  import PosSendInvoiceModal from './../pos/PosSendInvoiceModal'
  import SendMessageModal from './../sendout/SendMessageModal'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      recipient: Object,
    },
    components: {
      Coupons,
      PosSendInvoiceModal,
      SendMessageModal,
    },
    data() {
      return {
        trans: trans,
        iframeUrlPrefix: _.iframeUrlPrefix,
      }
    },
    computed: {
      autocancelDelay() {
        return !!this.organization.ecom_settings &&
          !!this.organization.ecom_settings.interac_autocancel_warning_minutes ?
          this.organization.ecom_settings.interac_autocancel_warning_minutes :
          60
      },
      session() {
        let session = ''
        if (window.session_id) {
          session = `?_session=${window.session_id}`;
        }
        return session
      },
      isCartEmptyOrExpired() {
        return !this.invoice || this.invoice.invoice_items.length == 0
      },
      bookingItems() {
        if (this.isCartEmptyOrExpired) return []
        return _.filter(this.invoice.invoice_items, item => {
          return !!item.booking
        })
      },
      canSendInvoice() {
        return !!this.organization.auth_user && !!this.invoice
      },
      continueShoppingUrl() {
        let url = `${_.iframeUrlPrefix}/org/${this.organization.id}`
        if (this.organization.has_stripe_terminal && !!this.organization.auth_user) url += '/products'
        return url + this.session
      },
      showAutocancelWarning() {
        return !!this.invoice &&
          this.invoice.has_interac_pending &&
          !this.invoice.is_no_client &&
          !!this.organization.ecom_settings &&
          this.organization.ecom_settings.interac_autodeposit &&
          this.organization.ecom_settings.interac_autocancel
      },
    },
    methods: {
      onInvoiceSent() {

      },
    },
    mounted() {
      window.checkoutConfirmation = this
    },
  }
</script>